import React, { useContext } from 'react';

import { splitTeamName } from 'scripts/helpers';
import { en } from 'scripts/translations';

import matchContext from 'scripts/context/match/matchContext';

import ScoreboxTeamBadge from 'scripts/components/common/Scorebox/ScoreboxTeamBadge';
import Countdown from 'scripts/components/common/Countdown/Countdown';
import citizenLogoBlack from 'i/team-player-backgrounds/Citizen_Logo_Black.png';
import citizenLogoWhite from 'i/team-player-backgrounds/Citizen_Logo_White.png';

import LazyLoadImage from '../../LazyLoadImage/LazyLoadImage';


/**
 * Scorebox used when the match hasn't started yet
 *
 * @returns {object} React render
 */
export default function Scorebox() {

    const { match } = useContext( matchContext );
    const { info, teams } = match;

    return (
        <div className="scorebox__main">
            <div className="scorebox__inner-container scorebox__inner-container--pre">
                <div className="scorebox__team-container scorebox__team-container--home">
                    <span className="scorebox__team-name" dangerouslySetInnerHTML={ splitTeamName( teams.home.shortName ) } />
                    <ScoreboxTeamBadge abbr={ teams.home.abbr } />
                </div>
                <div className="scorebox__countdown">
                    <span className="scorebox__countdown-label">{ en.match } { en.countdown }</span>
                    <div className="scorebox-countdown-container">
                        <Countdown datetime={ info.startTime }/>
                    </div>
                    <div className="scorebox__sponsor-wrapper">
                        <LazyLoadImage
                            src={ citizenLogoBlack }
                            pictureClassName={ 'scorebox__sponsor u-hide-tablet' }
                            imgClassName={ 'scorebox__sponsor-img' }
                            placeholder={ false }/>
                        <LazyLoadImage
                            src={ citizenLogoWhite }
                            pictureClassName={ 'scorebox__sponsor u-show-tablet' }
                            imgClassName={ 'scorebox__sponsor-img' }
                            placeholder={ false }/>
                        <span className={ 'scorebox__sponsor-label countdown__label' }>Official Timekeeper</span>
                    </div>
                </div>
                <div className="scorebox__team-container scorebox__team-container--away">
                    <ScoreboxTeamBadge abbr={ teams.away.abbr } />
                    <span className="scorebox__team-name" dangerouslySetInnerHTML={ splitTeamName( teams.away.shortName ) } />
                </div>
            </div>
        </div>
    );
}
